import {NgModule} from '@angular/core';
import {UiRenderIfPermittedDirective} from './uiRenderIfPermitted.directive';
import {EqualValidator} from "./equal-validator.directive";

@NgModule({
  imports: [],
  declarations: [
    UiRenderIfPermittedDirective,
    EqualValidator
  ],
  exports: [
    UiRenderIfPermittedDirective,
    EqualValidator
  ]
})
export class DirectivesModule {
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/shared/directives/directives.module.ts